import { formatDistanceToNow, differenceInDays } from "date-fns";
import { cn } from "@/lib/utils";
import type { InstallerSummary } from "@/types/edr-installers";

export function InstallersTable({
  rows,
  onSelect,
}: {
  rows: InstallerSummary[];
  onSelect: (id: string) => void;
}) {
  return (
    <div className="overflow-x-auto -mx-4 -my-4">
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-border bg-muted/30">
            {["Tag", "Platform", "Channel", "Version", "Enrolled", "Last enrolled", "Token expires", "Created by"].map((h) => (
              <th
                key={h}
                className="px-3 py-2 text-left font-semibold uppercase tracking-wider text-[10px] text-muted-foreground"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const days = differenceInDays(new Date(r.tokenExpiresAt), new Date());
            const expiryClass =
              days < 0
                ? "text-destructive"
                : days < 14
                  ? "text-warning-muted-foreground"
                  : "text-muted-foreground";
            return (
              <tr
                key={r.id}
                className="border-b border-border/60 hover:bg-muted/40 cursor-pointer"
                onClick={() => onSelect(r.id)}
              >
                <td className="px-3 py-2 text-foreground">{r.tagName}</td>
                <td className="px-3 py-2 text-muted-foreground capitalize">{r.platform}</td>
                <td className="px-3 py-2 text-muted-foreground capitalize">{r.channel}</td>
                <td className="px-3 py-2 text-muted-foreground font-mono">{r.version}</td>
                <td className="px-3 py-2 text-foreground tabular-nums">{r.enrolledCount}</td>
                <td className="px-3 py-2 text-muted-foreground tabular-nums">
                  {r.lastEnrolledAt
                    ? formatDistanceToNow(new Date(r.lastEnrolledAt), { addSuffix: true })
                    : "—"}
                </td>
                <td className={cn("px-3 py-2 tabular-nums", expiryClass)}>
                  {days < 0
                    ? "expired"
                    : formatDistanceToNow(new Date(r.tokenExpiresAt), { addSuffix: true })}
                </td>
                <td className="px-3 py-2 text-muted-foreground">{r.createdBy}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
